import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./RelatedProducts.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";

import { Navigation } from "swiper/modules";

import { API_BASE, getImageUrl } from "../../../api/client";

import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

/**
 * Real catalog items: same category as the current product when categoryId is set;
 * otherwise other visible products. Excludes the current PDP product.
 */
const RelatedProducts = ({ categoryId, excludeProductId }) => {
  const prevNavRef = useRef(null);
  const nextNavRef = useRef(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (excludeProductId == null) return undefined;
    let cancelled = false;
    setLoading(true);
    const qs = new URLSearchParams();
    if (categoryId != null && categoryId !== "") qs.set("categoryId", String(categoryId));
    const url = `${API_BASE}/api/products${qs.toString() ? `?${qs}` : ""}`;
    fetch(url)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((data) => {
        if (cancelled) return;
        const list = Array.isArray(data) ? data : [];
        const filtered = list.filter((p) => p.id !== excludeProductId).slice(0, 8);
        setItems(filtered);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [categoryId, excludeProductId]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (loading || items.length === 0) return null;

  return (
    <>
      <div className="relatedProductSection">
        <div className="relatedProducts">
          <h2>
            RELATED <span>PRODUCTS</span>
          </h2>
        </div>
        <div className="relatedProductSlider">
          <div ref={nextNavRef} className="swiper-button image-swiper-button-next">
            <IoIosArrowForward />
          </div>
          <div ref={prevNavRef} className="swiper-button image-swiper-button-prev">
            <IoIosArrowBack />
          </div>
          <Swiper
            key={excludeProductId}
            slidesPerView={4}
            slidesPerGroup={4}
            slidesPerGroupSkip={0}
            watchOverflow
            spaceBetween={30}
            loop={false}
            onBeforeDestroy={(swiper) => {
              swiper.autoplay?.stop?.();
            }}
            onBeforeInit={(swiper) => {
              const prev = prevNavRef.current;
              const next = nextNavRef.current;
              const n = swiper.params.navigation;
              swiper.params.navigation =
                typeof n === "object" && n !== null
                  ? { ...n, prevEl: prev, nextEl: next }
                  : { prevEl: prev, nextEl: next };
            }}
            navigation={{
              prevEl: prevNavRef.current,
              nextEl: nextNavRef.current,
            }}
            modules={[Navigation]}
            breakpoints={{
              320: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                slidesPerGroupSkip: 0,
                spaceBetween: 14,
              },
              768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                slidesPerGroupSkip: 0,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                slidesPerGroupSkip: 0,
                spaceBetween: 30,
              },
            }}
          >
            {items.map((product) => {
              const img = getImageUrl(product.first_image) || "";
              const priceRupee =
                product.min_price_paise != null
                  ? Math.round(Number(product.min_price_paise) / 100)
                  : null;

              return (
                <SwiperSlide key={product.id}>
                  <div className="rpContainer">
                    <Link to={`/product/${product.id}`} className="rpImages" onClick={scrollToTop}>
                      <img src={img} alt={product.name || ""} className="rpFrontImg" />
                      <img src={img} alt="" className="rpBackImg" aria-hidden />
                      <h4>Rent Now</h4>
                    </Link>

                    <div className="relatedProductInfo">
                      <div className="productNameInfo">
                        <Link to={`/product/${product.id}`} onClick={scrollToTop}>
                          <h5>{product.name}</h5>
                        </Link>
                        <p>
                          {priceRupee != null ? `₹${priceRupee.toLocaleString("en-IN")}` : "—"}
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default RelatedProducts;
